import { Link } from "gatsby";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import SvgCart from "../../assets/icons/SvgCart";
import SvgHeart from "../../assets/icons/SvgHeart";
import SvgLogo from "../../assets/icons/SvgLogo";
import Favorites from "./Favorites";
import NavMenu from "./NavMenu";
import PrimaryDrawer from "./PrimaryDrawer";
import Search from "./Search";
import * as styles from "./Navbar.module.css";

const country = process.env.GATSBY_LOCALE_COUNTRY;
function Navbar({ data }) {
  const [favoriteModal, setFavoriteModal] = useState(false);
  const [isOpenMobileMenu, setOpenMobileMenu] = useState(false);
  const { items, bundles } = useSelector((state) => state.cart);

  function toggleFavoriteModal() {
    setFavoriteModal(!favoriteModal);
  }

  return (
    <div
      className="group absolute bg-white flex flex-col justify-center z-[9] w-full mt-[37px] h-[50px] lg:h-[88px]"
      id="navbar"
      role="group"
    >
      <div className="flex items-center mx-5 xl:mx-[90px]">
        <React.Fragment>
          <NavMenu
              isOpenMobileMenu={isOpenMobileMenu}
              setOpenMobileMenu={setOpenMobileMenu}
              data={data}
          />
          <Link
              to="/"
              title="Bushbuck"
              className="bg-transparent py-2 cursor-pointer hidden lg:flex text-[#111]"
          >
            <SvgLogo
                color="inherit"
                style={{width: "140px", height: "36px"}}
            />
          </Link>
        </React.Fragment>
        <React.Fragment>
          <Link
              to="/"
              aria-label="Bushbuck Logo"
              className="flex lg:hidden items-center justify-center flex-grow cursor-pointer text-[#111]"
          >
            <SvgLogo
                color="inherit"
                style={{width: "140px", height: "36px", margin: "auto"}}
            />
          </Link>
          <div className="hidden lg:flex items-center justify-center grow">
            <PrimaryDrawer data={data.clothing}/>
            <PrimaryDrawer data={data.camping}/>
            {country !== "US" && country !== "GB" && (
                <PrimaryDrawer data={data.rooftopTents}/>
            )}

            <PrimaryDrawer data={data.accessories}/>
            {country !== "AU" && <PrimaryDrawer data={data.hunting}/>}

            {!data.hideBundles && (
                <Link
                    to="/collections/shop-bundles"
                    className={`${styles.nav_link} text-center py-[30px] px-4 xl:p-[30px] relative max-h-full no-underline font-bold cursor-pointer group max-w-7xl`}
                >
                  <div
                      className={`${styles.nav_link_top} absolute inset-0 opacity-0 w-full bg-black h-[0.4rem] border-0 rounded-bl-[1.5rem] rounded-br-[1.5rem] transition-opacity duration-300`}
                  />
                  <span className="text-center text-[#111] tracking-wide">
                    Bundles
                  </span>
              </Link>
            )}
            {!data.hideSale && (
                <div className="px-5 xl:px-6 py-5">
                  <Link
                      className={`text-xs sm:text-[15px] font-bold tracking-wider py-3 px-[35px]  text-center cursor-pointer
                h-12 flex leading-4 justify-center items-center box-border rounded-full appearance-none hover:scale-105 duration-200 transition-transform w-fit border border-solid
                border-white group-hover:border-[#1f1f1f] bg-[#1f1f1f] text-white`}
                      to={data.sale.slug}
                  >
                    {data.sale.title}
                  </Link>
                </div>
            )}
    </div>
          <div className="flex items-center justify-center gap-6">
            <Search/>
            <div
                className={`flex items-center cursor-pointer group-hover:hover:text-secondary-500 text-[#111] `}
                onClick={toggleFavoriteModal}
            >
              <SvgHeart style={{width: "21px", height: "21px"}}/>
            </div>
            <Link
                to="/cart"
                title="Cart"
                className={`nav-icon cursor-pointer hidden lg:flex items-center group-hover:hover:text-secondary-500 text-[#111]`}
            >
              <SvgCart
                  style={{width: "25px", height: "25px"}}
                  itemsInCart={!!(items.length > 0 || bundles.length > 0)}
              />
            </Link>
            <Link
                to="/cart"
                title="Cart"
                className={`flex lg:hidden items-center cursor-pointer group-hover:hover:text-secondary-500 text-[#111]`}
            >
              <SvgCart style={{width: "25px", height: "25px"}}/>
            </Link>
          </div>
          {favoriteModal && <Favorites toggle={toggleFavoriteModal}/>}
        </React.Fragment>
      </div>
    </div>
  );
}

export default React.memo(Navbar);
